<script setup>
import { computed, defineAsyncComponent } from 'vue';

const props = defineProps({
  type: {
    type: String,
    required: true,
    validator: value =>
      ['whatsapp', 'telegram', 'sms', 'instagram'].includes(value),
  },
  message: {
    type: String,
    default: '',
  },
  recipientName: {
    type: String,
    default: '',
  },
  recipientPhone: {
    type: String,
    default: '',
  },
  attachments: {
    type: Array,
    default: () => [],
  },
  recipients: {
    type: Array,
    default: () => [],
  },
  additionalColumns: {
    type: Array,
    default: () => [],
  },
});
// Lazy load preview components
const WhatsAppPreview = defineAsyncComponent(
  () => import('./MessagePreview/WhatsAppPreview.vue')
);
const TelegramPreview = defineAsyncComponent(
  () => import('./MessagePreview/TelegramPreview.vue')
);
const SmsPreview = defineAsyncComponent(
  () => import('./MessagePreview/SmsPreview.vue')
);
const InstagramPreview = defineAsyncComponent(
  () => import('./MessagePreview/InstagramPreview.vue')
);

// Map of preview components
const previewComponents = {
  whatsapp: WhatsAppPreview,
  telegram: TelegramPreview,
  sms: SmsPreview,
  instagram: InstagramPreview,
};

// Computed property to get the appropriate preview component
const previewComponent = computed(() => {
  return previewComponents[props.type] || null;
});

const isDarkMode = computed(() => {
  return document.body.classList.contains('dark');
});
</script>

<template>
  <div class="relative" :class="{ 'dark-mode': isDarkMode }">
    <!-- Dynamic preview component based on type -->
    <component
      :is="previewComponent"
      v-if="previewComponent"
      :message="message"
      :recipient-name="recipientName"
      :recipient-phone="recipientPhone"
      :attachments="attachments"
      :recipients="recipients"
      :additional-columns="additionalColumns"
    />

    <!-- Fallback for unsupported types -->
    <div v-else class="unsupported-preview">
      <div class="text-center text-gray-500 dark:text-gray-400 py-8">
        Preview não disponível para {{ type }}
      </div>
    </div>
  </div>
</template>

<style scoped>
/* Fallback preview styles */
.unsupported-preview {
  background: #f5f5f5;
  border-radius: 16px;
  padding: 20px;
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dark-mode .unsupported-preview {
  background: #1a1a1a;
}
</style>
